import { useExportTable, useRequest, useResetState } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import type { Application, ApplicationsResponse, WithRejectReson, WithUser } from "./types";
import { deleteApplicationThunk, getApplicationsThunk, putApplicationThunk } from "./thunks";
import { ApiRouteTypes } from "consts/enpoints/api";
import { changeExportLoading, resetState } from "./slice";

export const useActions = () => {
    const getApplications = useRequest<ThunkReturnType<ApplicationsResponse>, string | undefined>({
        thunk: getApplicationsThunk
    });

    const updateApplication = useRequest<
        ThunkReturnType<ResourceResponse<Application>>,
        WithUser & Partial<WithRejectReson<Application>>
    >({
        thunk: putApplicationThunk
    });

    const deleteApplication = useRequest<ThunkReturnType<ResourceResponse<ID>>, WithUser>({
        thunk: deleteApplicationThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetMerchants
    });

    const resetApplications = useResetState(resetState);

    return {
        getApplications,
        updateApplication,
        deleteApplication,
        downloadCsv,
        resetApplications
    };
};

export default useActions;
